import { ArticleParagraph3, ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { VillageImg } from '../VillageImg/VillageImg';

interface IPromoAuthorProps {
  villageLogoUrl?: string | null;
  villageName: string;
}

export function PromoAuthor({ villageLogoUrl, villageName }: IPromoAuthorProps) {
  return (
    <div className={styles['container']}>
      {villageLogoUrl && <VillageImg villageLogoUrl={villageLogoUrl} />}
      <div>
        <ArticleParagraph3 color="gray60_100">Акция от застройщика</ArticleParagraph3>
        <ArticleParagraph1 color="black_100">{villageName}</ArticleParagraph1>
      </div>
    </div>
  );
}
